export enum CleaningStatusTypeEnum {
    Unknown = -1,
    NotNecessary = 0,
    Necessary = 1,
}


export function cleaningStatusEnumLabel(status: CleaningStatusTypeEnum): string {
    switch (status) {
        case CleaningStatusTypeEnum.NotNecessary:
            return "enum.cleaningStatus.notNecessary";
        case CleaningStatusTypeEnum.Necessary:
            return "enum.cleaningStatus.necessary";
        default:
            return "common.unknown";
    }
}